/**
 * useHaptic - Hook pour le retour haptique (vibration)
 * Fournit des fonctions de vibration pour améliorer l'UX sur mobile
 */

// Patterns de vibration prédéfinis (en millisecondes)
export const HAPTIC_PATTERNS = {
  light: 10,        // Vibration légère - pour les interactions simples
  medium: 25,       // Vibration moyenne - pour les sélections
  heavy: 50,        // Vibration forte - pour les confirmations
  success: [30, 50, 30], // Pattern succès
  error: [50, 30, 50, 30, 50], // Pattern erreur
  warning: [30, 20, 30], // Pattern avertissement
  tap: 15,          // Tap simple
  longPress: 100,   // Appui long détecté
};

/**
 * Déclenche une vibration si supportée par l'appareil
 * @param {number|number[]} pattern - Durée en ms ou pattern [vibrate, pause, vibrate, ...]
 */
export const vibrate = (pattern = HAPTIC_PATTERNS.tap) => {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    try {
      navigator.vibrate(pattern);
    } catch (e) {
      // Silently fail if vibration not supported
    }
  }
};

/**
 * Hook personnalisé pour le retour haptique
 */
export const useHaptic = () => {
  const isSupported = typeof navigator !== 'undefined' && 'vibrate' in navigator;

  const tap = () => vibrate(HAPTIC_PATTERNS.tap);
  const light = () => vibrate(HAPTIC_PATTERNS.light);
  const medium = () => vibrate(HAPTIC_PATTERNS.medium);
  const heavy = () => vibrate(HAPTIC_PATTERNS.heavy);
  const success = () => vibrate(HAPTIC_PATTERNS.success);
  const error = () => vibrate(HAPTIC_PATTERNS.error);
  const warning = () => vibrate(HAPTIC_PATTERNS.warning);
  const longPress = () => vibrate(HAPTIC_PATTERNS.longPress);

  return {
    isSupported,
    tap,
    light,
    medium,
    heavy,
    success,
    error,
    warning,
    longPress,
    vibrate, // Pour les patterns personnalisés
  };
};

export default useHaptic;
